import * as actions from "../../../actions/budget/edit";

const initialBudgetState = {
  status: "",
  clientId: "",
  city: "",
  code: "",
  people: "",
  moreInfo: "",
  phoneNumber: "",
  startDate: "",
  endDate: "",
  deliveryType: "",
  deliveryAddress: "",
  mount: false,
  discount: false,
  item: null,
  errors: {}
};

const initialState = {
  loading: false,
  ...initialBudgetState
};

const reducer = function(state = initialState, { type, payload }) {
  switch (type) {
    case actions.SET_VALUE: {
      return {
        ...state,
        ...payload
      };
    }
    case actions.CLEAR_VALUE: {
      if (state.item) {
        return {
          ...state,
          ...initialBudgetState,
          ...state.item,
          item: state.item
        };
      } else {
        return {
          ...state,
          ...initialBudgetState
        };
      }
    }
    case actions.GET_BUDGET: {
      return {
        ...state,
        loading: true
      };
    }
    case actions.EDIT_BUDGET: {
      return {
        ...state,
        loading: true
      };
    }
    case actions.GET_BUDGET_FAILED: {
      return {
        ...state,
        loading: false
      };
    }
    case actions.EDIT_BUDGET_FAILED: {
      return {
        ...state,
        loading: false
      };
    }
    case actions.EDIT_BUDGET_SUCCESS: {
      return {
        ...state,
        ...initialBudgetState,
        loading: false
      };
    }
    case actions.GET_BUDGET_SUCCESS: {
      return {
        ...state,
        item: payload,
        ...payload,
        moreInfo: payload.moreInfo || "",
        loading: false
      };
    }
    default: {
      return state;
    }
  }
};

export default reducer;
